var _path, _rect, _rect2, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 112,
    viewBox: "0 0 136 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134 44C137.669 90.9168 99.4457 112 69.3092 112C39.1727 112 0 86.6592 0 59.6696C0 32.6801 7.19355 15.8734 37.5085 5.46611C67.8235 -4.94119 130.331 -2.91677 134 44Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46.75,
    y: 27.6667,
    width: 42.5,
    height: 16.3462,
    rx: 1,
    fill: "#F5F6FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50.0193,
    y: 30.9357,
    width: 9.80769,
    height: 9.80769,
    rx: 0.576923,
    fill: "#D2D2D8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.75,
    y: 48.9712,
    width: 42.5,
    height: 16.3461,
    rx: 1,
    fill: "#F5F6FB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.0193,
    y: 52.2402,
    width: 9.80769,
    height: 9.80769,
    rx: 0.576923,
    fill: "#D2D2D8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.75,
    y: 70.2756,
    width: 42.5,
    height: 16.3461,
    rx: 1,
    fill: "#F5F6FB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.0193,
    y: 73.5446,
    width: 9.80769,
    height: 9.80769,
    rx: 0.576923,
    fill: "#D2D2D8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyList);
export default __webpack_public_path__ + "static/media/empty-list.fd88eac6b6fbf01485004cf134f3ee9c.svg";
export { ForwardRef as ReactComponent };